import { useState } from "react"
import { Box, Typography, Divider, Button, Alert, IconButton, Grid } from "@mui/material"
import HighlightOffIcon from '@mui/icons-material/HighlightOff'

import email from '../../assets/svg/email.svg'
import mobile from '../../assets/svg/mobile.svg'

import { useSelector } from "react-redux"
import { useAppData } from "../../redux/appDataProvider"
import ApiClient from "../../utilities/apiClient"
import AppConfig from "../../AppConfig"


const InfoScreen = ({ fieldType, onNext, onClose }) => {
    const { userInfo, setUserInfo } = useAppData()
    const [error, setError] = useState(false)
    const [errorMsg, setErrorMsg] = useState("")

    const apiToken = useSelector(state => state.auth.apiToken)

    const handleSendOtp = () => {
        const payload = {
            clientId: userInfo.CLIENT_ID,
            email: userInfo.CLIENT_ID_MAIL,
            mobileNumber: userInfo.MOBILE_NO,
            updateType: fieldType === 'email' ? 'email' : 'mobile',
            fullName: userInfo.CLIENT_NAME
        }

        try {

            const apiClient = new ApiClient(apiToken)

            apiClient
                .fetchData(AppConfig.api.Profile.sendOtp, "POST", payload)
                .then((response) => {
                    if (!response) {
                        console.error("Error: Response is missing.")
                        setError(true)
                        return
                    }

                    if (response.status === 200 && response.data.success) {
                        onNext()
                    } else if ((response.status === 500 || response.status === 400) && !response.data.success) {
                        if (response.data?.message?.includes("Maximum OTP")) {
                            setErrorMsg(response.data.message)
                        }

                        setError(true)
                        console.log("Error:", response.data?.message)
                    } else {
                        setError(true)
                        console.warn("Unexpected response status:", response.status)
                    }

                })
                .catch((error) => {
                    console.error("Error during API request (Promise rejection):", error)
                    setError(true)
                })
        } catch (error) {
            console.error("Error during API request (Try block) :", error)
            setError(true)
        }
    }


    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Box sx={{ flexGrow: 1 }}>
                <Grid container alignItems="center" justifyContent="space-between">
                    <Grid item>
                        <Typography sx={{ fontSize: {xs: '14px', sm: '16px'}, fontWeight: 600 }}>
                            Update your {fieldType === 'email' ? 'Email' : 'Mobile'} on TradeBoss
                        </Typography>
                    </Grid>
                    <Grid item>
                        <IconButton onClick={onClose}>
                            <HighlightOffIcon sx={{ color: '#F3D45E' }} />
                        </IconButton>
                    </Grid>
                </Grid>

                <Divider sx={{ my: 2, borderColor: "#999" }} />

                <Typography sx={{ color: "#999", mb: 3, fontSize: {xs: '14px', sm: '16px'} }}>Usually takes few seconds</Typography>

                <Box textAlign="center" mb={3}>
                    <img src={fieldType === 'email' ? email : mobile} alt="OTP" width={250} height={250} />
                </Box>

                <Typography sx={{ fontSize: {xs: '14px', sm: '16px'}, fontWeight: 600, mb: 2 }}>
                    You are about to change your {fieldType === 'email' ? 'Email' : 'Mobile Number'} on TradeBoss.
                </Typography>

                <Box component="ul" sx={{ pl: 2, color: "#ccc", fontSize: 14, mb: 4 }}>
                    <li>We will send OTPs to authenticate the request.</li>
                    <li>This update may take up to 24–48 hours.</li>
                    <li>You will be logged out of all devices after the update.</li>
                </Box>

                {error && <Alert severity="error" >
                    {errorMsg || "Error in Send OTP. Please try later."}
                </Alert>}
            </Box>

            <Box>
                <Button onClick={handleSendOtp} fullWidth>
                    Proceed
                </Button>
            </Box>
        </Box>
    )
}


export default InfoScreen
